import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/LandingPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/header/SpectraHeader.tsx");
